module.exports = __webpack_public_path__ + "static/media/TalentCardPic.ae12ee63.png";